import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Grow from '@mui/material/Grow';

import styles from './styles.module.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />;
});

const AlertAfterSubmit = (props) => {
  const { children, toggle, isShowAlert, classNameAdd, link, state, labelOnOk } = props;

  return (
    <>
      <Dialog
        open={isShowAlert}
        onClose={toggle}
        TransitionComponent={Transition}
        keepMounted
        className={classNames(`${styles.modalAlert} ${classNameAdd && classNameAdd}`)}
      >
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          {link && (
            <NavLink
              to={{
                pathname: link,
                state: state,
              }}
              className={styles.linkDone}
            >
              <Button data-dismiss="modal" type="button" onClick={toggle}>
                {labelOnOk ?? 'Done'}
              </Button>
            </NavLink>
          )}
          {!link && (
            <Button data-dismiss="modal" type="button" onClick={toggle}>
              {labelOnOk ?? 'Done'}
            </Button>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default AlertAfterSubmit;
